import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { ConstantService } from "../../../../components/common/utils/constant.service";
import { ClienteLogin, Cliente, ClienteXCiudad } from "../../../login/cliente_login";
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { PolizaEntity } from '../../entities/polizas_cliente_entity';
import { VamTitularEntity } from '../../../vam/titulares/entities/vam_titulares_entity';
import { InclusionEntity, ExclusionEntity, ExclusionVam, Exclusiones } from '../../entities/vam_entities';


declare var jQuery: any;

@Injectable()
export class SolicitudExclusionService {
    private userEmpresa: ClienteXCiudad;
    private url = "vamEmpresas";

    constructor(private authHttp: AuthHttp, private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }

    consultarTitularesDependientes(poliza: PolizaEntity):Observable<VamTitularEntity[]>{
        let body = JSON.stringify(poliza);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultarListados", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    
    enviarSolicitudExclusion(listadoExclusiones: ExclusionVam):Observable<boolean[]>{
        let body = JSON.stringify(listadoExclusiones);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/enviarSolExclusion", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    consultarExclusiones(exclusion: Exclusiones):Observable<Exclusiones[]>{
        let body = JSON.stringify(exclusion);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultarExclusiones", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/vamEmpresa/solicitudes/solicitud-exclusion.service.ts